import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, TextField, Button } from "@mui/material";
import { Formik } from "formik";
import Loader from "../../../shared/components/Loader";
import { useNavigate } from "react-router-dom";
import { dynamicVS } from "../../../shared/validation/validation";
import { listDynamicURl,updateDynamicURl } from "../../../services/settingService";
import { IconButton } from "@material-ui/core";
import { ArrowBack } from "@mui/icons-material";
import { dynamicKey } from "../../../utils/constant";
import { toastMessage } from "../../../shared/components/Toast";
function Reward() {

  const [loyalBonus, setLoyalBonus] = useState("");
  const [referalBonus, setReferalBonus] = useState("");
 
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let cloneState = {};
    let obj = {};
    let query = "REFERRAL_BONUS_VALUE,LOYALTY_BONUS_VALUE"
    listDynamicURl(query)
      .then(({ data }) => {
        let selectedKey = [
          {
            key: "REFERRAL_BONUS_VALUE",
            statePropty: "refereal_bonus_value",
          },
          {
            key: "LOYALTY_BONUS_VALUE",
            statePropty: "loyal_bonus",
          },
        ];

        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let findKey = selectedKey.find((ii) => ii.key === element?.key);
          if (findKey && Object.keys(findKey)?.length) {
            obj = {
              ...obj,
              [findKey.statePropty]: element.value,
            };
          }
        }
        obj = {
          ...cloneState,
          ...obj,
        };
        setReferalBonus(obj?.refereal_bonus_value)
        setLoyalBonus(obj?.loyal_bonus)
      })
      .catch((err) => {
      });
  }, []);
  const handleUpdate = (key,values)=>{
    let obj = {
      value:values
    }

    updateDynamicURl(key,obj).then(({data})=>{
      toastMessage("Dynamic key value is successfully updated","success");
    }).catch((err)=>{
      toastMessage(err?.response?.data?.message,"error");
    })
  }
  const handleSubmit = (key) => {
    if(dynamicKey.referalBonus == key){
      handleUpdate(key,referalBonus)
    }else if(dynamicKey.loyalReaward == key){
      handleUpdate(key,loyalBonus)
    }
  };
  return (
    <Box className="">
      <Box
        borderBottom={"1px solid #B9C5D275"}
        flexDirection={"column"}
        display={"flex"}
      >
        <Typography
          variant="h5 "
          fontFamily={"inter"}
          fontSize={"20px"}
          fontWeight={600}
          sx={{ mb: 1, mt: 3, ml: 3, color: "#2F496C" }}
        >
          Reward
        </Typography>

        <Typography
          variant="body6"
          fontFamily={"inter"}
          fontSize={"12px"}
          fontWeight={400}
          sx={{ mb: 2.5, ml: 3, color: "#899CAF" }}
        >
          One Place for your all links to control integrity Referral Program
        </Typography>
      </Box>
      
        <Box display={"flex"} justifyContent={"center"}>
          <Box sx={{ mt: 5, pb: 5 }} border={"1px solid #B9C5D275"}>
            <Box display={"flex"} bgcolor={"#F8F8F8"} sx={{ py: 2 }}>
              <span onClick={() => navigate(-1)}>
                <ArrowBack />
              </span>
              <Typography variant="body5" sx={{ ml: 2 }}>
                Links List
              </Typography>
            </Box>
            {/*-------------------- input ----------------------*/}
            <Box sx={{ px: 3 }}>
              <Grid container spacing={1}>
                <Grid xs={12}>
                  <Box sx={{ mt: 2 }}>
                    <Typography
                      variant="body5"
                      fontFamily={"inter"}
                      fontSize={"12px"}
                      fontWeight={500}
                      color={"#899CAF"}
                      sx={{ ml: 0.7 }}
                      id="starick"
                    >
                      Referral Reward
                    </Typography>
                  </Box>
                  <Box
                    component="form"
                    sx={{
                      "& > :not(style)": { mt: 1.5 },
                      "& .MuiInputBase-root": {
                        height: 50,
                      },
                      "& .MuiFormControl-root": {
                        width: "100%",
                      },
                      "& .MuiBox-root": {
                        display: "flex",
                      },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      name="offer_tital"
                      sx={{
                        "& > :not(style)": {
                          width: "100%",
                          border: "1px solid",
                        },
                      }}
                      placeholder="Referral Bonus"
                      type={"number"}
                      value={referalBonus}
                      onChange={(e) => setReferalBonus(e.target.value)}
                    />
                    <Button
                      style={{
                        background: "rgb(248, 61, 75)",
                        color: "white",
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        "&:hover": {
                          backgroundColor: "rgb(248, 61, 75)",
                          color: "white",
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                        },
                      }}
                      onClick={() => handleSubmit(dynamicKey.referalBonus)}
                    >
                      Update
                    </Button>
                  </Box>
                </Grid>
                <Grid xs={12}>
                  <Box sx={{ mt: 2 }}>
                    <Typography
                      variant="body5"
                      fontFamily={"inter"}
                      fontSize={"12px"}
                      fontWeight={500}
                      color={"#899CAF"}
                      sx={{ ml: 0.7 }}
                      id="starick"
                    >
                      Loyal Reward
                    </Typography>
                  </Box>
                  <Box
                    component="form"
                    sx={{
                      "& > :not(style)": { mt: 1.5 },
                      "& .MuiInputBase-root": {
                        height: 50,
                      },
                      "& .MuiFormControl-root": {
                        width: "100%",
                      },
                      "& .MuiBox-root": {
                        display: "flex",
                      },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      name="offer_tital"
                      sx={{
                        "& > :not(style)": {
                          width: "100%",
                          border: "1px solid",
                        },
                      }}
                      placeholder="Referral Bonus"
                      type={"number"}
                      value={loyalBonus}
                      onChange={(e) => setLoyalBonus(e.target.value)}
                    />
                    <Button
                      style={{
                        background: "rgb(248, 61, 75)",
                        color: "white",
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        "&:hover": {
                          backgroundColor: "rgb(248, 61, 75)",
                          color: "white",
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                        },
                      }}
                      onClick={() => handleSubmit(dynamicKey.loyalReaward)}
                    >
                      Update
                    </Button>
                  </Box>
                </Grid>
                
              </Grid>
            </Box>
          </Box>
        </Box>
    </Box>
  );
}
export default Reward